import localforage from 'localforage'
import $ from 'jquery'

let localforageStoreRooms = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'rooms'
})

const initialState = {
  all: [],
  room: {
    roomId: null,
    surveyId: null,
    roomNameId: null
  }
}

let state = initialState

const getters = {
  getAllRooms: state => state.all
}

const actions = {
  loadAllRooms ({ commit }) {
    return new Promise((resolve, reject) => {
      let rooms = []
      localforageStoreRooms.iterate(function (value, key, iterationNumber) {
        rooms.push(JSON.parse(value))
      }).then(function () {
        commit('receiveRooms', rooms)
        resolve(rooms)
      })
    })
  },
  loadRoomsForSurvey ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      let key = 'survey-' + surveyId
      let rooms = []
      localforageStoreRooms.startsWith(key).then((results) => {
        if (results) {
          $.each(results, (index, value) => {
            rooms.push(JSON.parse(value))
          })
        }
        commit('receiveRooms', rooms)
        resolve()
      })
    })
  },
  addRoom ({ commit }, { surveyId, nextRoomId, roomNameId }) {
    return new Promise((resolve, reject) => {
      let key = 'survey-' + surveyId + '-room-' + nextRoomId
      let room = { roomId: nextRoomId, surveyId: surveyId, roomNameId: roomNameId }
      localforageStoreRooms.setItem(key, JSON.stringify(room)).then(() => {
        commit('receiveRoom', room)
        resolve()
      })
    })
  },
  importRooms ({ commit }, rooms) {
    return new Promise((resolve, reject) => {
      commit('clearRoomsState')
      rooms.forEach((room) => {
        const key = 'survey-' + room.surveyId + '-room-' + room.roomId
        localforageStoreRooms.setItem(key, JSON.stringify(room)).then(() => {
          commit('receiveRoom', room)
        })
      })
      resolve()
    })
  },
  deleteSurveyRooms ({ commit, state }, surveyId) {
    return new Promise((resolve, reject) => {
      // get localforage keys of all objs to be deleted
      let keys = []
      localforageStoreRooms.iterate((result, key) => {
        result = JSON.parse(result)
        if (result.surveyId === surveyId) {
          keys.push({
            'key': key,
            'id': result.id
          })
        }
      },
      () => {
        // success callback: delete all objs from localforage, resolve once all keys have been processed
        let counter = 0
        keys.forEach((result) => {
          localforageStoreRooms.removeItem(String(result.key)).then(() => {
            commit('removeRoomFromState', result.id)
            counter++
            if (counter === keys.length) {
              resolve()
            }
          })
        })
        if (counter === 0) {
          resolve()
        }
      })
    })
  },
  clearRoomsStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreRooms.clear().then(() => {
        commit('clearRoomsState')
        resolve()
      })
    })
  }
}

const mutations = {
  receiveRoom (state, room) {
    state.all.push(room)
  },
  receiveRooms (state, rooms) {
    state.all = rooms
  },
  removeRoomFromState (state, roomId) {
    let index = state.all.findIndex(x => x.id === roomId)
    state.all.splice(index, 1)
  },
  clearRoomsState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/rooms.js